import React from 'react';
import { Heading } from '@innovationnorway/cl-react';
import { SivaGoalsDetailsDto } from 'src/api/v2';
import GoalFeedback from './GoalFeedback';

type Props = {
  clusterId: string;
  year: number;
  currentYear?: SivaGoalsDetailsDto;
  previousYear?: SivaGoalsDetailsDto;
  readMode?: boolean;
  showCommentedOnly?: boolean;
  setSivaHasSubmittedComment?: React.Dispatch<React.SetStateAction<boolean>>;
};

const SivaGoalsList: React.FC<Props> = ({
  clusterId,
  year,
  currentYear,
  previousYear,
  readMode,
  showCommentedOnly,
  setSivaHasSubmittedComment,
}) => {
  const uniqueCategories = Array.from(
    new Set((currentYear?.goalAccomplishments || []).map((goal) => goal.goalCategory.id)),
  );

  const data = uniqueCategories
    .map((category) => {
      return {
        category: (currentYear?.goalAccomplishments || []).find((goal) => goal.goalCategory.id === category)
          ?.goalCategory,
        goals: (currentYear?.goalAccomplishments || [])
          .filter((goal) => goal.goalCategory.id === category)
          .map((goal) => ({
            goal: goal,
            prev: previousYear?.goalAccomplishments.find(
              (prevGoal) => prevGoal.goalDetail.code === goal.goalDetail.code,
            ),
          })),
      };
    })
    .filter((item) => {
      if (showCommentedOnly) {
        return item.goals.some((goal) => !!goal.goal.sivaComment);
      }

      return true;
    });

  return (
    <div>
      {data.map(({ category, goals }) => {
        return (
          <div key={category?.id}>
            <Heading level={2}>{category?.name}</Heading>

            {goals?.map(({ goal, prev }) => (
              <GoalFeedback
                key={`${goal.id}${goal.sivaComment ?? ''}`}
                clusterId={clusterId}
                year={year}
                goal={goal}
                previousGoal={prev}
                readMode={readMode}
                setSivaHasSubmittedComment={setSivaHasSubmittedComment}
              />
            ))}
          </div>
        );
      })}
    </div>
  );
};

export default SivaGoalsList;
